import { render, staticRenderFns } from "./GoodsPublishStep2.vue?vue&type=template&id=149026c3&scoped=true"
import script from "./GoodsPublishStep2.vue?vue&type=script&lang=js"
export * from "./GoodsPublishStep2.vue?vue&type=script&lang=js"
import style0 from "./GoodsPublishStep2.vue?vue&type=style&index=0&id=149026c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149026c3",
  null
  
)

export default component.exports